<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button type="button" class="btn-close" nofocus (click)="activeModal.dismiss('close')"></button>
</div>
<div class="modal-body">
  {{ body }}
</div>
<div class="modal-footer">
  @if (options.showCancel) {
    <button type="button" class="btn btn-secondary" (click)="activeModal.close('cancel')">Annuleren</button>
  }
  @if (options.showOk) {
    <button type="button" class="btn btn-primary" (click)="activeModal.close('ok')">Oké</button>
  }
  @if (options.showSave) {
    <button type="button" class="btn btn-success" (click)="activeModal.close('save')">Opslaan</button>
  }
  @if (options.showClose) {
    <button type="button" class="btn btn-primary" (click)="activeModal.close('close')">Sluiten</button>
  }
  @if (options.showInleveren) {
    <button type="button" class="btn btn-primary" (click)="activeModal.close('inleveren')">Inleveren</button>
  }
  @if (options.showVersturen) {
    <button type="button" class="btn btn-primary" (click)="activeModal.close('versturen')">Versturen</button>
  }
</div>
